module.exports = __webpack_public_path__ + "img/model4.6cb5ac7d.png";